import { formatApiErrorMessage } from './apiErrorMessage';

const SIREN_API_NOT_FOUND = '요청한 API를 찾기 불가';

/** 경광등 API 호출 실패 시 — 404면 고정 문구만 표시 */
export function formatSirenApiErrorMessage(error: unknown, fallback: string): string {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status === 404) {
    return SIREN_API_NOT_FOUND;
  }
  const msg = formatApiErrorMessage(error, fallback);
  if (msg.includes('요청한 API를 찾기 불가')) {
    return SIREN_API_NOT_FOUND;
  }
  return msg;
}

export { SIREN_API_NOT_FOUND };
